import React from "react";
import { useTranslation } from "react-i18next";
const getLegendContainerStyle = (schoolApp) => ({
  position: "absolute",
  bottom: "2px",
  left: schoolApp ? "2px" : "2px",
  backgroundColor: "rgba(255,255,255,0.95)",
  borderRadius: schoolApp ? "16px" : "8px",
  padding: schoolApp ? "2px 2px" : "3px 4px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
  zIndex: 1100,
  fontSize: schoolApp ? "9px" : "11px",
  fontFamily: "Arial, sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: schoolApp ? "8px" : "14px",
  flexWrap: "wrap",
  pointerEvents: "none",
});

const rowStyle = { display: "flex", alignItems: "center", gap: "5px" };

const toTitleCase = (value = "") =>
  value
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
  


function MapLegend({
  vehicleIconUrl,
  showVehicle = false,
  statusItems = [],
  routeColors = [],
  stopItems = [],
  placeItems = [],
  showDirection = false,
  directionLabel = "legendDirectionOfTravel",
  directionIcon = "➡️",
  style = {},
  schoolApp = false,
}) {

  const { t } = useTranslation();

  const uniqueRoutes = [...new Set(routeColors.filter(Boolean))];
  const uniquePlaces = [
    ...new Map(
      (placeItems || [])
        .filter((item) => item?.type)
        .map((item) => [item.type, item]),
    ).values(),
  ];

  const hasContent =
    (showVehicle && vehicleIconUrl) ||
    statusItems.length > 0 ||
    uniqueRoutes.length > 0 ||
    stopItems.length > 0 ||
    uniquePlaces.length > 0 ||
    showDirection;

  if (!hasContent) return null;

  return (
    <div style={{ ...getLegendContainerStyle(schoolApp), ...style }}>
      {showVehicle && vehicleIconUrl && (
        <div style={rowStyle}>
          <img
            src={vehicleIconUrl}
            alt="vehicle"
            style={{
              width: schoolApp ? "18px" : "28px",
              height: schoolApp ? "18px" : "28px",
              borderRadius: schoolApp ? "9px" : undefined,
            }}
          />
          {schoolApp ? t("Student") : t("Vehicle")}
        </div>
      )}

      {statusItems.map((item) => (
        <div key={item.label} style={rowStyle}>
          <span
            style={{
              display: "inline-block",
              width: "24px",
              height: "12px",
              backgroundColor: item.color || "#888",
              borderRadius: "6px",
              border: `1.5px solid ${item.borderColor || item.color || "#888"}`,
            }}
          />
          {t(item.label)}
        </div>
      ))}

      {uniqueRoutes.length > 0 && (
        <div style={rowStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "3px",
            }}
          >
            {uniqueRoutes.map((color, index) => (
              <span
                key={`${color}-${index}`}
                style={{
                  display: "inline-block",
                  width: schoolApp ? "16px" : "24px",
                  height: schoolApp ? "3px" : "4px",
                  backgroundColor: color,
                  borderRadius: "2px",
                }}
              />
            ))}
          </div>
          {t("Route")}
        </div>
      )}

      {stopItems.map((item) => (
        <div key={item.label} style={rowStyle}>
          {item.iconUrl ? (
            <img
              src={item.iconUrl}
              alt={item.label}
              style={{
                width: schoolApp ? "12px" : "18px",
                height: schoolApp ? "12px" : "18px",
              }}
            />
          ) : (
            <span
              style={{
                display: "inline-block",
                width: schoolApp ? "8px" : "12px",
                height: schoolApp ? "8px" : "12px",
                backgroundColor: item.color || "#d32f2f",
                borderRadius: "50%",
              }}
            />
          )}
          {t(item.label)}
        </div>
      ))}

      {uniquePlaces.map((place) => (
        <div key={place.type} style={rowStyle}>
          {place.icon ? (
            <img
              src={place.icon}
              alt={place.label || place.type}
              style={{ width: "16px", height: "16px" }}
            />
          ) : (
            <span
              style={{
                display: "inline-block",
                width: "12px",
                height: "12px",
                backgroundColor: "#555",
                borderRadius: "50%",
              }}
            />
          )}
          {t(place.label) || t(toTitleCase(place.type))}
        </div>
      ))}

      {showDirection && (
        <div style={rowStyle}>
          <span>{directionIcon}</span>
          {t(directionLabel)}
        </div>
      )}
    </div>
  );
}

export default React.memo(MapLegend);
